var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1200,
    width: 1600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#effaff",
    width: 1600,
    height: 1200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1112.08 280.76H511.2V605.89H1112.08V280.76Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M689.14 406.45H934.27",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.14 604.09V358.6",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.27 544.5V358.6",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.27 604.09V560.64",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.2 386.65H708.4V534.6H915.2V386.65Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.07 406.45H844.25V456.32H866.07V406.45Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.08 406.45H736.26V456.32H758.08V406.45Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.26 514.99V472.45",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.71 514.99V472.45",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.35 514.99V406.45",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.16 514.99V406.45",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.61 514.99V406.45",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.52 440.73V406.45",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.52 473H844.25V514.99H887.52V473Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.14 372.9H934.27",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.2 386.65V358.78H708.4V386.65H736.26 915.2Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.26 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.71 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.35 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.16 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.61 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.25 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.07 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.52 376.75V386.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M968.75 707.12H1025.68V976.37H968.75 911.94V716.63H968.75Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.99 586.05H877.51L867.82 519.92 833.26 523.4 843.7 595.37C846.31 613.77 862.22 627.44 880.87 627.44H911.45V721.52L973.97 721.52H979.57L973.6 729.5 1004.55 749.39 1035.63 708.36C1043.71 697.8 1048.18 684.75 1048.18 671.45V627.81C1048.18 604.69 1029.66 585.8 1006.54 585.8H1001.07L992.99 586.05Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.01 647.58V634.9",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.57 722.04L1012.01 680.02V655.04",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.75 976.37L968.75 785.56",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.75 772.88V757.09",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.25 560.69C924.25 560.69 933.7 554.23 955.2 554.23 976.71 554.23 986.15 560.69 986.15 560.69 988.14 565.16 989.51 570.26 989.51 575.36 989.51 579.09 988.89 582.57 987.77 586.05 987.4 587.04 987.15 587.66 986.78 588.66 981.55 600.96 969.37 609.67 955.08 609.67 939.79 609.67 926.98 599.85 922.51 586.05 921.39 582.69 920.77 579.09 920.77 575.36 920.89 570.26 922.01 565.16 924.25 560.69Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.43 571.13V583.91",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.63 584.06C946.63 586.67 944.51 588.78 941.9 588.78 939.29 588.78 937.43 586.72 937.43 583.93",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.2 541.17C968.75 541.17 980.56 549.13 986.15 560.81H924.25C929.6 549.13 941.4 541.17 955.2 541.17Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M711.58 707.91L595.21 707.91 587.87 723.84 588.08 975.91 724.09 975.91 723.89 723.84 711.58 707.91Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.87 623.3V630.85 723.73H723.89V681.84H821.12V664.67C821.12 650.6 809.74 639.23 795.67 639.23H743.02V596.09C743.02 580.06 729.99 566.93 713.85 566.93H644.04C613.21 567.24 587.87 592.37 587.87 623.3Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.82 600.85C664.69 600.85 647.55 583.71 647.55 562.58 647.55 541.45 664.69 524.31 685.82 524.31 706.96 524.31 724.09 541.45 724.09 562.58 724.09 583.71 706.96 600.85 685.82 600.85Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.82 524.31C664.72 524.31 647.55 541.48 647.55 562.58 647.55 565.79 647.86 568.89 648.59 571.99 657.59 571.48 664.83 563.93 664.83 554.72V543.86H719.03C712.51 532.27 700.1 524.31 685.82 524.31Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.99 556.06V568.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.99 568.48C702.99 571.58 700.61 573.86 697.62 573.86 694.62 573.86 692.24 571.48 692.24 568.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.09 681.95V618.64",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.87 626.81V691.77C587.87 696.63 589.11 701.5 591.7 705.63L626.87 766.56 663.69 745.25 628 683.39 624.9 678.02C634.62 678.02 642.59 670.05 642.59 660.33",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.87 626.81V691.77C587.87 696.63 589.11 701.5 591.7 705.63L626.87 766.56 663.69 745.25 628 683.39 624.9 678.02C634.62 678.02 642.59 670.05 642.59 660.33",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.14 976.12V812.38",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.14 798.62V780.42",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437 391.38H384.02V349.68C384.02 335.07 395.9 323.19 410.51 323.19 425.12 323.19 437 335.07 437 349.68V391.38Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.51 323.28V232.53",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39 359.76V391.47H285.41V349.68C285.41 335.07 297.29 323.19 311.9 323.19 326.51 323.19 338.39 335.07 338.39 349.68",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39 359.76V391.47H285.41V349.68C285.41 335.07 297.29 323.19 311.9 323.19 326.51 323.19 338.39 335.07 338.39 349.68",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9 323.28V232.53",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.87 391.38H186.89V349.68C186.89 335.07 198.76 323.19 213.38 323.19 227.99 323.19 239.87 335.07 239.87 349.68V391.38Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.38 253.8V232.53",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.38 323.28V260.21",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.71 976.55H459.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.88 976.55H1208.73 1227.47 1518.42",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.13 976.55H1135",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.66 976.55H1083.98",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1438.92 393.34H1385.66V351.42C1385.66 336.73 1397.6 324.79 1412.29 324.79 1426.98 324.79 1438.92 336.73 1438.92 351.42V393.34Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.29 324.88V233.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.79 361.56V393.43H1286.53V351.42C1286.53 336.73 1298.47 324.79 1313.16 324.79 1327.85 324.79 1339.79 336.73 1339.79 351.42",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.79 361.56V393.43H1286.53V351.42C1286.53 336.73 1298.47 324.79 1313.16 324.79 1327.85 324.79 1339.79 336.73 1339.79 351.42",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.16 324.88V233.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.75 393.34H1187.49V351.42C1187.49 336.73 1199.43 324.79 1214.12 324.79 1228.81 324.79 1240.75 336.73 1240.75 351.42V393.34Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.12 255.04V233.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.12 324.88V261.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1424.42 806.81H1291.81V796.95C1291.81 787.45 1299.48 779.78 1308.98 779.78H1407.25C1416.75 779.78 1424.42 787.45 1424.42 796.95V806.81Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.94 806.81V976.93",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.32 976.93C1310.32 950.63 1331.75 929.32 1358.06 929.32 1384.36 929.32 1405.67 950.75 1405.67 976.93",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1221.46 682.14V737.89L1354.6 737.89V694.17 661.27H1221.46V682.14Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.1 671.33C1224.1 684.11 1234.34 694.36 1247.13 694.36H1336.54C1357.23 694.36 1374.15 677.63 1374.15 656.75V620.37C1374.15 586.24 1346.51 558.6 1312.38 558.6H1284.08 1248.63C1228.61 558.6 1212.25 574.86 1212.25 594.98V618.02 633.44L1197.86 636.45 1137.22 649.05 1150.67 688.63 1212.34 673.87 1224.1 671.33Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.46 727.36H1354.6V976.42H1221.46V727.36Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.6 679.13L1214.32 679.32 1190.34 618.02H1277.59L1292.07 654.97 1301.66 679.32 1225.6 679.13Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.71 517.32C1267.72 517.32 1251.83 524.19 1247.88 541.96 1247.22 544.78 1246.94 547.6 1246.94 550.61 1246.94 572.51 1264.71 590.38 1286.71 590.38 1300.63 590.38 1313.23 582.86 1320.37 571.95 1324.51 565.74 1321.97 558.6 1321.97 550.61 1321.97 528.7 1308.71 517.32 1286.71 517.32Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.71 511.02C1308.53 511.02 1326.48 528.7 1326.48 550.79 1326.48 558.6 1324.13 565.84 1320.37 571.95 1312.76 571.95 1306.64 565.84 1306.64 558.22V541.86H1247.98C1251.93 523.9 1267.81 511.02 1286.71 511.02Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268 553.8V565.84",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268 565.84C1268 568.85 1270.35 571.1 1273.27 571.1 1276.28 571.1 1278.53 568.75 1278.53 565.84",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.03 976.42V796.84",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.03 787.72V771.18",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.96 637.57V656.75C1373.96 677.44 1357.23 694.36 1336.36 694.36H1246.94C1234.16 694.36 1223.91 684.11 1223.91 671.33V663.71 654.97H1314.64L1332.31 654.78C1324.04 654.78 1317.36 648.2 1317.36 639.83",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.96 637.57V656.75C1373.96 677.44 1357.23 694.36 1336.36 694.36H1246.94C1234.16 694.36 1223.91 684.11 1223.91 671.33V663.71 654.97H1314.64L1332.31 654.78C1324.04 654.78 1317.36 648.2 1317.36 639.83",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.45 735.61L207.33 723.78 271.32 735.61V974.54H143.45V735.61Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88 626.17L357.44 612.29 376.63 655.56 271.32 707.19V735.61H143.45V716.95C129.02 716.95 117.2 705.24 117.2 690.7V631.49C117.2 599.71 143.01 573.89 174.79 573.89H235.86C254.62 573.89 269.69 589.08 269.69 607.73V650.9L316.01 630.51",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88 626.17L357.44 612.29 376.63 655.56 271.32 707.19V735.61H143.45V716.95C129.02 716.95 117.2 705.24 117.2 690.7V631.49C117.2 599.71 143.01 573.89 174.79 573.89H235.86C254.62 573.89 269.69 589.08 269.69 607.73V650.9L316.01 630.51",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.79 535.83C224.79 535.83 192.58 516.52 165.9 541.14 160.37 546.24 149.52 561.53 157.98 581.7 166.66 595.04 182.71 602.53 199.3 599.49 228.48 594.18 242.25 560.01 224.79 535.83Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.99 552.96L214.27 565.87",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.64 567.82C204.19 570.75 207 572.7 209.93 572.16 212.86 571.62 214.81 568.8 214.27 565.87",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55 519.77C156.25 524.98 142.04 557.41 157.87 581.7 167.63 579.97 174.03 570.64 172.19 560.88L169.48 546.02 224.68 535.93C215.9 523.57 200.5 516.85 184.55 519.77Z",
    fill: "#49476e",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09 602.96H235.1L226.74 654.8 247.68 646.34 264.16 694.07 223.82 710.23H290.84L308.09 602.96Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.45 716.95H206.9L223.82 710.23",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.02 648.41C170.02 659.03 161.45 667.6 150.82 667.6H195.07L226.85 654.8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.11 791.35V778.34",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.11 974.54V800.68",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.cba82e710fecb663262319b9412db8f9.svg";
export { ForwardRef as ReactComponent };